export default {"src":"/_next/static/media/bewegingsprogramma.6bf1fa50.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};